module.exports = __webpack_public_path__ + "img/review_reward.a714e120.png";